<template>
  <div class="page-container">
    <!-- 搜索栏 -->
    <div>
      <div class="page-card__header">
        <el-row>
          <el-col :span="4">
            展品信息（共：{{aSum}}）
          </el-col>
          <el-col :span="2">
            <el-button round size="small" @click="add_p"> 添加展品</el-button>
          </el-col>
          <el-col :span="6" :offset="12">

            <el-input v-model="input">
              <el-button slot="append" icon="el-icon-search" @click="serach"></el-button>
            </el-input>
          </el-col>
        </el-row>


      </div>

    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      style="width: 100%;padding: 0 20px;"
    >
          <el-table-column
        prop="id"
        label="ID"
        width="100"
      >
      </el-table-column>

      <el-table-column
        prop="title"
        label="产品名称"
      >
      </el-table-column>

      <el-table-column
        prop="user.name"
        label="公司名称"
        width="200"
      >
      </el-table-column>

      <el-table-column
        prop="img"
        label="产品图"
        width="80"
      >
        <template slot-scope="scope">
          <el-image style="width:35px" :src="productImg + scope.row.img+'?x-oss-process=image/resize,w_200'"></el-image>
        </template>
      </el-table-column>


      <el-table-column
        prop="type"
        label="分类"

      >
      </el-table-column>
      <el-table-column
        prop="view"
        label="浏览数"
        width="80"
      >
      </el-table-column>
      <el-table-column
        prop="praise"
        label="点赞数"
        width="80"
      >
      </el-table-column>

      <el-table-column
        prop="create_time"
        label="加入日期">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="handleClick(scope.row)">详情</el-button>
          <el-button type="text" class="action-btn--danger" @click="deleteClick(scope.row)">删除</el-button>
        </template>
      </el-table-column>


    </el-table>

    <!-- 分页器 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {

    data() {
      return {
        productImg: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/product/',
        input: '',
        tableData: [],
        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,
      }
    },
    mounted() {
      this.datalist()

    },
    methods: {
      /** 跳转到展品详情页 */
      handleClick(row) {
        this.$router.push({name: 'admin_productDetail', query: {id: row.id, user: row.user}})
      },

      /** 获取展品列表数据 */
      datalist() {
        let url = this.baseUrl + '/admin/products/';
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        })
      },

      /** 删除展品信息 */
      deleteClick(row) {
        this.$confirm('将删除此条信息，是否继续', '提示', {
          confirmButtonText: "确定",
          cancelButtonText: '取消',
          type: "warning"
        }).then(() => {
          let id = row.id;
          let url = this.baseUrl + "/admin/products/" + id + "/";
          api.deleteData(url).then(res => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.datalist();
          })
        })
      },


      /** 按名称搜索展品 */
      serach() {
        let url = this.baseUrl + '/admin/products/?title__icontains='+this.input;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        })

      },

      /** 分页切换处理 */
      handleCurrentChange(val) {
        let url = this.baseUrl + '/admin/products/?&page=' + val+"&title__icontains="+this.input;
        api.fetchData(url).then(res => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        })

      },

      /** 跳转到添加展品页面 */
      add_p() {
        this.$router.push({name: "admin_addProduct"})
      },

    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/productList.vue